// EOH - Custom: Function to truncate the collection hero description text below 900px viewport width
function truncateDescription(descriptionElement) {

	// Check if the element exists, otherwise exit the function
  if (!descriptionElement) {
    return;
  }

  const isMobile = window.innerWidth < 900;
  const existingLink = descriptionElement.nextElementSibling;
  const applyOnDesktop = descriptionElement.getAttribute('data-apply-read-more-on-desktop');
  const hasControlLink = existingLink && (existingLink.classList.contains('read-more-link') || existingLink.classList.contains('read-less-link'));

  // Helper function to apply truncation styles
  const applyTruncationStyles = () => {
    descriptionElement.style.display = '-webkit-box';
    descriptionElement.style.webkitBoxOrient = 'vertical';
    descriptionElement.style.overflow = 'hidden';
    descriptionElement.style.webkitLineClamp = '3';
  };

  // Helper function to remove truncation styles
  const removeTruncationStyles = () => {
    descriptionElement.style.removeProperty('display');
    descriptionElement.style.removeProperty('webkit-box-orient');
    descriptionElement.style.removeProperty('overflow');
    descriptionElement.style.removeProperty('webkit-line-clamp');
  };

  // Helper function to create a link
  const createLink = (text, className, onClickHandler) => {
    const link = document.createElement('a');
    link.href = '#';
    link.classList.add(className);
    link.textContent = text;
    link.style.display = 'block';
    link.style.marginTop = '10px';
    link.style.textDecoration = 'underline';
    link.style.cursor = 'pointer';
    link.addEventListener('click', onClickHandler);
    return link;
  };

  if (isMobile || applyOnDesktop) {
    // Only apply initial truncation if not already expanded (checking for 'read-less-link')
    if (!(existingLink?.classList.contains('read-less-link'))) {
      applyTruncationStyles();
    }

    if (!hasControlLink) {
      const readMoreLink = createLink('Read more', 'read-more-link', (event) => {
        event.preventDefault();
        removeTruncationStyles();
        readMoreLink.remove();

        const readLessLink = createLink('Read less', 'read-less-link', (e) => {
          e.preventDefault();
          applyTruncationStyles();
          readLessLink.remove();
          // Re-insert "Read more" link if it was removed
          descriptionElement.parentNode.insertBefore(readMoreLink, descriptionElement.nextSibling);
        });
        descriptionElement.parentNode.insertBefore(readLessLink, descriptionElement.nextSibling);
      });
      descriptionElement.parentNode.insertBefore(readMoreLink, descriptionElement.nextSibling);
    }
  }
  else {
    removeTruncationStyles();
    if (hasControlLink) {
      existingLink.remove();
    }
  }
}

function truncateDescriptions() {
  const descriptionElements = document.querySelectorAll('[data-read-more-element]');

  descriptionElements.forEach((descriptionElement) => {
    truncateDescription(descriptionElement)
  });
}

truncateDescriptions();
window.addEventListener('resize', function() {
	truncateDescriptions();
});

// EOH - Custom: Function to handle chat/loyalty icons on mobile, when sticky add to cart bar is visible and shift icons up to sit above the sticky bar
function handleIconsFixedToBottomWhenStickyAddToCartIsVisible() {
  const stickyAddToCartBar = document.querySelector('.sticky-atc-bar--show');
  const chatIcon = document.querySelector('inbox-online-store-chat#ShopifyChat');
  const loyaltyIcon = document.querySelector('#smile-ui-lite-launcher-frame-container');

  if (stickyAddToCartBar && (chatIcon || loyaltyIcon)) {
    const stickyBarHeight = stickyAddToCartBar.offsetHeight;
    const icons = [chatIcon, loyaltyIcon].filter(Boolean);

    icons.forEach(icon => {
      icon.style.bottom = `${stickyBarHeight + 4}px`;
    });
  } else {
    // Reset the bottom position when the sticky bar is not visible
    if (chatIcon) chatIcon.style.bottom = '30px';
    if (loyaltyIcon) loyaltyIcon.style.bottom = '30px';
  }
}

handleIconsFixedToBottomWhenStickyAddToCartIsVisible();
window.addEventListener('scroll', function() {
  handleIconsFixedToBottomWhenStickyAddToCartIsVisible();
});